import { default as hello, HelloJSLoginOptions } from 'hellojs';

import { OAuthProviderType } from '../contracts/SharedProperties';
import initalizeIdp from './initalizeIdp';

interface LoginOptions extends HelloJSLoginOptions {
    clientId: string;
}

export type LoginConfig = { [provider: string]: LoginOptions };

export default function loginToIdp(provider: OAuthProviderType, options?: LoginOptions) {
    if (provider == OAuthProviderType.ICloud) {
        // ICloud is not currently supported and the openICloudCredentialPromptDialog method was
        // removed, check the history of history of this file for the change that removed the
        // dialog.
        return null;
    } else {
        initalizeIdp(provider, options.clientId);
        return hello.login(provider.toString(), options);
    }
}
